common.View.create('canvas.blocks.custom.videoWithPlaceholder.Block', {

    onDOMLoad() {
        this.initStartVideo();
    },

    initStartVideo() {
        // Find video
        let videoSrc = this.element.find('.embedded-video');

        // Hide video by default
        videoSrc.hide();

        // Find play button
        this.element.find('.play-button').click((e) => {

            // Add z-index so the toolbar from vimeo works
            videoSrc.addClass('z-30');

            // If video has source
            if (videoSrc.attr('src')) {

                // Add autoplay
                videoSrc[0].src += '&autoplay=true';

                // Prevent default
                e.preventDefault();

                // Show iframe video with fadein
                videoSrc.fadeIn('slow');

                // Hide image overlay with fadeout
                this.element.find('.hide-when-video-started').fadeOut('slow');
            }
        });
    },
});
